import { Dispatch, Reducer, useReducer } from "react";

export type ReturnType<IState> = [IState, Dispatch<Partial<IState>>];

type ReducerType<IState> = Reducer<IState, Partial<IState>>;

const init = <IState,>(initialState: IState) => ({ ...initialState });

const reducer = <IState,>(currentState: IState, newState: Partial<IState>) => ({
  ...currentState,
  ...newState,
});

const useSetState = <IState,>(initialState: IState): ReturnType<IState> => {
  const [state, setState] = useReducer<ReducerType<IState>, IState>(
    reducer,
    initialState,
    init,
  );

  return [state, setState];
};

export default useSetState;
